
const m = window.require("frontend/config/environment");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
